// src/pages/CourseTime/components/slides/layouts/AssessmentResultSlide.comp.jsx
import React from 'react';
import * as S from '../../../styles';
import SlideTitleSpoken from '../common/SlideTitleSpoken.comp';
import { GET_APP_LOCALIZE_TEXT } from '../../../../../utils/dq_lc_service/lc_service';
import { SESSION_SCORE_LEVELS, SESSION_SCORE_MIN, getSessionScoreLevel } from '../../../utils/sessionScoreLevel';

// Layout: ASSESSMENT_RESULT
const AssessmentResultSlide = ({
  slide,
  renderSpokenText,
  skipTitleSpeech,
  assessmentScore,
  assessmentResultLoading,
  pageLc
}) => {
  // Use assessmentScore if available, otherwise fall back to slide content score
  const displayScore = assessmentScore !== null && assessmentScore !== undefined
    ? assessmentScore
    : (slide.SlideContent?.score || 0);
  const isZeroScore = Number(displayScore) === 0;
  // Rubric row to highlight: the level of the same score the ring shows, but without
  // the ring's 0 fallback. While loading or with no score, no row is highlighted.
  const currentLevel = assessmentResultLoading
    ? null
    : getSessionScoreLevel(assessmentScore ?? slide.SlideContent?.score);

  return (
    <S.QuizResultContainer>
      <S.ResultContent>
        <S.SlideTitle style={{textAlign:'center'}}>
          <SlideTitleSpoken slide={slide} skipTitleSpeech={skipTitleSpeech} renderSpokenText={renderSpokenText} />
        </S.SlideTitle>
        <S.ResultBody>
          <S.ScoreContainer>
            {/* ScoreContent skeleton vs actual */}
            <S.ScoreContent>
              {assessmentResultLoading ? (
                <>
                  <S.ScoreSkeletonCircle />
                  <S.ScoreSkeletonLine width="70%" height="18px" />
                  <S.ScoreSkeletonLine width="45%" height="14px" />
                </>
              ) : (
                <>
                  <S.ScoreSpinner className={'score-spinner'}>
                    <S.ScoreInt isZero={isZeroScore}>
                      {parseFloat(displayScore).toFixed(2).split('.')[0]}
                    </S.ScoreInt>
                    <S.ScoreLabelPt isZero={isZeroScore}>
                      .{parseFloat(displayScore).toFixed(2).split('.')[1]}
                    </S.ScoreLabelPt>
                  </S.ScoreSpinner>
                  <S.ScoreDesc>{slide.SlideContent?.description || GET_APP_LOCALIZE_TEXT(pageLc, 'ct__your_session_score')}</S.ScoreDesc>
                </>
              )}
            </S.ScoreContent>

            {/* RubricContainer skeleton vs actual */}
            <S.RubricContainer>
              {assessmentResultLoading ? (
                <S.RubricContent>
                  {[1, 2, 3, 4].map((row) => (
                    <S.RubricSkeletonRow key={row}>
                      <S.RubricSkeletonBadge />
                      <S.RubricSkeletonContent>
                        <S.ScoreSkeletonLine width="60%" height="16px" />
                        <S.ScoreSkeletonLine width="40%" height="12px" />
                      </S.RubricSkeletonContent>
                    </S.RubricSkeletonRow>
                  ))}
                </S.RubricContent>
              ) : (
                <S.RubricContent role="table">
                  <S.RubricHeaderRow role="row">
                    <S.RubricHeaderCell role="columnheader">{GET_APP_LOCALIZE_TEXT(pageLc, 'ct__rubric_level')}</S.RubricHeaderCell>
                    <S.RubricHeaderCell role="columnheader">{GET_APP_LOCALIZE_TEXT(pageLc, 'ct__rubric_description')}</S.RubricHeaderCell>
                  </S.RubricHeaderRow>
                  {SESSION_SCORE_LEVELS.map(({ level, band, max }, index) => {
                    const isCurrent = level === currentLevel;
                    return (
                      <S.RubricRow key={level} role="row" $band={band} $current={isCurrent} aria-current={isCurrent ? 'true' : undefined}>
                        {/* Score scale: the row's upper bound, plus the floor under the last row */}
                        <S.RubricScaleTick $band={band} aria-hidden="true">{max}</S.RubricScaleTick>
                        {index === SESSION_SCORE_LEVELS.length - 1 && (
                          <S.RubricScaleTick $floor aria-hidden="true">{SESSION_SCORE_MIN}</S.RubricScaleTick>
                        )}
                        <S.RubricLevelCell role="rowheader" $band={band}>
                          {GET_APP_LOCALIZE_TEXT(pageLc, 'result_quiz__cpci_' + band)}
                        </S.RubricLevelCell>
                        <S.RubricDescCell role="cell" $current={isCurrent}>
                          {GET_APP_LOCALIZE_TEXT(pageLc, 'ct__rubric_desc_' + band)}
                        </S.RubricDescCell>
                      </S.RubricRow>
                    );
                  })}
                </S.RubricContent>
              )}
            </S.RubricContainer>
          </S.ScoreContainer>
        </S.ResultBody>
      </S.ResultContent>
    </S.QuizResultContainer>
  );
};

export default AssessmentResultSlide;
